import Sheet from "react-modal-sheet";
import { useDispatch } from "react-redux";
import { updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { VIDEO_CDN } from "@/config/constants";

const CameraHelp = () => {
  const dispatch = useDispatch();

  const resetState = () => {
    dispatch(updateOffCanvasViewPayload({ CAMERA: { help: false } }));
  }

  return (
    <>
      <Sheet.Scroller className="flex flex-col gap-8">
        <div>
          <video autoPlay loop className="px-8" src={`${VIDEO_CDN}/DEMO/WEB/QA/capture-1.mp4`}></video>
        </div>
        <div>
          <video autoPlay loop className="px-8" src={`${VIDEO_CDN}/DEMO/WEB/QA/crop-1.mp4`}></video>
        </div>
        <div>
          <video autoPlay loop className="px-8" src={`${VIDEO_CDN}/DEMO/WEB/QA/select-1.mp4`}></video>
        </div>
      </Sheet.Scroller>
      <div className="flex justify-center my-4">
        <button className="btn-secondary" onClick={resetState}>Close</button>
      </div>
    </>
  );
}

export default CameraHelp;